import { render } from "./post.html?vue&type=template&id=19b2a084&scoped=true&ts=true"
import script from "./post.ts?vue&type=script&lang=ts"
export * from "./post.ts?vue&type=script&lang=ts"

import "./post.scss?vue&type=style&index=0&id=19b2a084&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b2a084"]])

export default __exports__